const WindowProvider = window;
export default WindowProvider;
